<script setup lang="ts">
import type { Url } from '@global-types/url.ts';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { computed } from 'vue';
import PlusMenuItem from '@layout/nav-v2/mobile/components/PlusMenuItem.vue';

interface PlusMenuLinkProps {
  link: Url,
  hasPin?: boolean,
}

const props = withDefaults(defineProps<PlusMenuLinkProps>(), {
  hasPin: false,
});

const { isCurrentPage } = useNavbarStore();

const isActive = computed<boolean>(() => isCurrentPage(props.link));
</script>

<template>
  <a
    :href="link"
    class="no-underline"
  >
    <PlusMenuItem
      :is-active="isActive"
      :has-pin="hasPin"
    >
      <template #icon>
        <slot name="icon" :is-active="isActive" />
      </template>

      <template #text>
        <slot name="text" />
      </template>
    </PlusMenuItem>
  </a>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;

.menu-plus-link {
  @media (hover: hover) {
    &:hover {
      background-color: $colorBlueLightest;
    }
  }

  &__pin {
    background-color: $colorRed;
    border: 1px solid $colorWhite;
  }
}
</style>
